<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("profile.profile") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">{{ $t("profile.profile") }}</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- Form groups used in grid -->

          <form>
            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("profile.name")
              }}</label>
              <div class="col-md-2">
                <base-input placeholder="" v-model="profile.FName"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("profile.lname")
              }}</label>
              <div class="col-md-2">
                <base-input placeholder="" v-model="profile.LName"></base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("birthday")
              }}</label>
              <div class="col-md-2">
                <base-input >
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ allowInput: true }"
                  class="form-control datepicker"
                  v-model="profile.BirthDay"
                >
                </flat-picker>
              </base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("lmg.email")
              }}</label>
              <div class="col-md-2">
                <base-input v-model="profile.Email">
              </base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("lmg.agent_code")
              }}</label>
              <div class="col-md-2">
                <base-input v-model="profile.AgentCode">
              </base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("lmg.taxid")
              }}</label>
              <div class="col-md-2">
                <base-input v-model="profile.TaxID">
              </base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("lmg.tel")
              }}</label>
              <div class="col-md-2">
                <base-input v-model="profile.Tel">
              </base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("lmg.with_holding_tax")
              }}</label>
              <div class="col-md-1">
                <base-input v-model="profile.WithholdingTax">
              </base-input>
              </div>
            </div>


            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("lmg.address")
              }}</label>
              <div class="col-md-6">
                <base-input v-model="profile.Address">
              </base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("lmg.city")
              }}</label>
              <div class="col-md-3">
                <base-input v-model="profile.City">
              </base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("lmg.province")
              }}</label>
              <div class="col-md-3">
                <base-input v-model="profile.Province">
              </base-input>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-label">{{
                $t("lmg.postcode")
              }}</label>
              <div class="col-md-2">
                <base-input v-model="profile.Postcode">
              </base-input>
              </div>
            </div>

           



            <div class="form-group row">
              <div class="offset-md-2 col-md-10">
                <base-button type="primary" @click="handleUpdate()">{{
                  $t("save")
                }}</base-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import numbers from "./numbers";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "CreateNumber",
  components: {
flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      getUser: "Auth/getUser",
    })
  },
  data() {
    return {
      profile: {
      }
    };
  },
  async mounted() {
    let resp = await this.getProfile()
    this.profile = resp.data.Data[0]
    
    
    // this.profile.name = this.getUser.FName;
    // this.profile.lname = this.getUser.LName;
  },

  methods: {
    ...mapActions({
      setUser: "Auth/setUser",
      changeProfile: "Auth/changeProfile",
      changePassword: "Auth/changePassword",
      getProfile: "Auth/getProfile",
      
    }),
    filesChange(files) {
      this.inputs.file = files;
    },
    handleUpdate() {
      this.changeProfile({
fname: this.profile.FName,
lname: this.profile.LName,
birthDay: this.profile.BirthDay,
agentCode: this.profile.AgentCode,
withholdingTax: this.profile.WithholdingTax,
taxID: this.profile.TaxID,
tel: this.profile.Tel,
email: this.profile.Email,
address: this.profile.Address,
city: this.profile.City,
province: this.profile.Province,
postcode: this.profile.Postcode,
      })
        .then(resp => {
          swal
            .fire({
              title: this.$t("profile.change_profile_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            .then(result => {

            });
        })
        .catch(err => {
          swal.fire({
            title: this.$t("errors.profile.change_profile_failed"),
            text: this.$t(err.response.data.Msg),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.2rem !important;
}
</style>
